export const VEHICLE_DOCUMENT_NAMES = [
  'cvo_coc',
  'aangifte_bpm',
  'bvi_document',
  'betaalbevestiging',
  'cmr_export',
  'cmr_import',
  'dhl',
  'duitse_brief_export_document',
  'factuur_inkomend',
  'factuur_uitgaand',
  'import_rapport_silverdat',
  'kenteken_buitenlands',
  'machtigingsformulier',
  'mededeling_bpm_bedrag',
  'orderbevestiging',
  'credit_invoice',
  'document_new_statement',
  'overige',
  'proforma_factuur_export',
  'registratie_buitenland',
  'exa_confirmed',
  'exa_not_confirmed',
  'cmr_export_goederen_ontvangen',
  'rdw_tellerrapport',
  'tdn',
  'tuv_rapport',
  'verslag_opname_bedrijfsvoorraad',
  'vrijwaringsbewijs'
]


export const COMPANY_DOCUMENT_NAMES = [
  'bedrijvenformulier',
  'btw_uittreksel',
  'iban_check',
  'id',
  'kvk',
  'overig',
  'website',
  'schermafdruk_vestigingsadres',
  'schermafdruk_vies_adres',
  'vies_check',
  'overige_bescheiden'
];


export const USER_DOCUMENT_NAMES = ['ID_front', 'ID_back', 'copy_bank_card'];
